import { Claims } from "./Claims";
import { IPermission } from "./IPermission";

export class UserPermissions {
    public static readonly MaintainUsers: Array<IPermission> = Claims.Roles.createPermissions([Claims.Roles.Administrator])
    public static readonly PasswordReset: Array<IPermission> = Claims.Roles.createPermissions([Claims.Roles.Administrator])
}